import type { ProductCardTranslations } from "./pl";

export const en: ProductCardTranslations = {
  addToCart: "Add to cart",
  cartComingSoon:
    "The shopping cart will be available in the next migration step.",
  priceFrom: "From:",
  badges: {
    bestseller: "Bestseller",
    recomended: "Recommended",
    new: "New",
  },
  status: {
    temporary_unavailable: "Temporarily unavailable.",
    archive: "Archived.",
    in_set: "Available only as part of a set.",
  },
  formatPrice: (value: number, currency: string): string => {
    const rounded = (Math.round(value * 100) / 100).toFixed(2);
    return currency ? `${rounded} ${currency}` : rounded;
  },
  lowestPrice: (formatted: string): string =>
    `Lowest price in the last 30 days: ${formatted}`,
};
